import api from '@/api'

const state = {
  users: [],
  loading: false,
  error: null
}

const mutations = {
  SET_USERS(state, users) {
    state.users = users
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  }
}

const actions = {
  async fetchUsers({ commit }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const response = await api.get('/users')
      commit('SET_USERS', response.data)
    } catch (error) {
      commit('SET_ERROR', 'Error al cargar usuarios')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createUser({ commit, dispatch }, userData) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.post('/users', userData)
      await dispatch('fetchUsers')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al crear usuario'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateUser({ commit, dispatch }, { id, userData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.put(`/users/${id}`, userData)
      await dispatch('fetchUsers')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al actualizar usuario'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteUser({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await api.delete(`/users/${id}`)
      await dispatch('fetchUsers')
      
      return { success: true }
    } catch (error) {
      const message = error.response && error.response.data && error.response.data.message || 'Error al eliminar usuario'
      commit('SET_ERROR', message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async initialize({ dispatch }) {
    try {
      await dispatch('fetchUsers')
    } catch (error) {
      // Error initializing users module - handled silently
    }
  }
}

const getters = {
  users: state => state.users,
  loading: state => state.loading,
  error: state => state.error,
  
  activeUsers: state => state.users.filter(user => user.status === 'active'),
  inactiveUsers: state => state.users.filter(user => user.status === 'inactive'),
  
  getUserById: state => id => {
    return state.users.find(user => user.id === id)
  },
  
  getUsersByRole: state => role => {
    return state.users.filter(user => user.role === role)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 


// WEBPACK FOOTER //
// ./src/store/modules/users.js